export const isFullStatic = false
export const staticPath = "/builds/_yzHE-br/1/swifter-software/dobry-gabinet/frontend/src/node_modules/.cache/nuxt/static-json"
export const publicPath = "/"
export const globalContext = "__NUXT__"
export const globalNuxt = "$nuxt"